import { useEffect } from "react"
import { DrawerActionButton, DrawerBackground, DrawerContainer, DrawerFooterContainer, DrawerMainContent, DrawerTitle, DrawerTitleContainer } from "../styled/Drawer.style"

export interface DrawerProps {
    previewCustomClass?: string
    drawerMainContentCustomClass?: string
    onClose: any
    titleImageDetail?: string
    children?: JSX.Element
    onOpenCb?: Function
}

const Drawer = (props: DrawerProps) => {
    const { previewCustomClass, drawerMainContentCustomClass, onClose, titleImageDetail, children, onOpenCb } = props

    useEffect(() => {
        onOpenCb && onOpenCb()
     // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (<>
        <DrawerContainer className={previewCustomClass}>
            {titleImageDetail && <DrawerTitleContainer>
                <DrawerTitle className={previewCustomClass}>{titleImageDetail}</DrawerTitle>
            </DrawerTitleContainer>}
            <DrawerMainContent className={drawerMainContentCustomClass}>
                {children}
            </DrawerMainContent>
            <DrawerFooterContainer>
                <DrawerActionButton
                    className={previewCustomClass}
                    onClick={onClose} >
                    CHIUDI
                </DrawerActionButton>
            </DrawerFooterContainer>
        </DrawerContainer>
        <DrawerBackground onClick={onClose}></DrawerBackground>
    </>)
}

export default Drawer